module.exports = __webpack_public_path__ + "img/event-atelier-ms-fevrier-2025.ff4c3bb.jpg";